import { useOutletContext } from "react-router";

import { type CollectionRecord } from "@/shared/domain/collections";

/**
 * Typed accessor for the outlet context the `Collection` page publishes
 * to its child tab routes. Keeps the `CollectionRecord` cast in one place
 * so per-tab consumers don't repeat it.
 *
 * Throws if called outside a `<Collection />` outlet — react-router's
 * `useOutletContext` returns `null` in that case, which the hook surfaces
 * as a named error so the misuse points at this hook rather than at a
 * downstream destructure.
 */
export function useCollectionOutletContext(): CollectionRecord {
  const context = useOutletContext<CollectionRecord | null>();
  if (context === null) {
    throw new Error(
      "useCollectionOutletContext must be called inside a <Collection /> outlet",
    );
  }
  return context;
}
